import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
// Cloud React components
import { Button } from 'Components';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { NotificationManager } from 'Components/Notifications';
import { Grid } from '@mui/material';
import { OrderData } from 'Core/data/Helpers';
import { Chip } from 'Components';

//actions
import {
    clearRedux,
    mapGeofencesContactsGetGeofence,
    mapGeofencesOpenContactsModal,
    mapGeofencesOpenEditCreateModal,
    mapGeofencesContactsSave,
    getLandmarksAndGeofences as getKmls
} from 'Redux/actions';


const GeofenceContacts = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();

    const {
        open,
        id,
        geofence,
        loadingGeofence,
        response,
        loadingResponse
    } = useSelector((state) => state.realtimeMapGeofenceContactsRedux);

    const [contacts, setContacts] = useState([]);

    useEffect(() => {
        return () => {
            dispatch(clearRedux("MAP_GEOFENCE_CONTACTS"));
        }
    }, []);

    useEffect(() => {
        if (id && open) {
            dispatch(mapGeofencesContactsGetGeofence(id));
        }
    }, [id, open]);

    useEffect(() => {
        if (response && open) {
            if (response.error) {
                NotificationManager.error(
                    response.message || messages['errorMessage'],
                    messages['error'],
                    3000,
                    null,
                    null,
                    'warning',
                );
            } else {
                dispatch(getKmls());
            }

            dispatch(clearRedux("MAP_GEOFENCE_CONTACTS", { response: null }));
        }
    }, [response, open]);

    useEffect(() => {
        if (geofence && open) {
            if (geofence.error) {
                NotificationManager.error(
                    messages['errorMessage'],
                    messages['error'],
                    3000,
                    null,
                    null,
                    'warning',
                );
            } else {
                setContacts(geofence?.contacts || []);
            }
        }
    }, [geofence, open]);

    const handleClose = useCallback(() => {
        setContacts([]);
        dispatch(mapGeofencesOpenContactsModal(false));
        dispatch(clearRedux("MAP_GEOFENCE_CONTACTS"));
    });

    return (
        <Modal
            title={`${messages['map_geofence_geofenceContacts_title']} '${geofence?.name || ""}'`}
            open={open}
            loading={loadingGeofence || loadingResponse}
            position="right"
            size="small"
            style={{ overflow: 'hidden' }}
            className="overflow-hidden modal-top-0"
            headerStyle={{
                top: 0
            }}
            handleClose={handleClose}
        >
            <ModalBody style={{ marginBottom: 0 }}>
                <div style={{ padding: 24, height: "calc(100vh - 225px)" }}>
                    {
                        contacts?.length ?
                            <Grid
                                container
                                direction="column"
                                justifyContent="flex-start"
                                alignItems="flex-start"
                            >
                                {OrderData(contacts, 'title').map((contact, index) => {
                                    return (
                                        <Grid
                                            item
                                            xs={12}
                                            key={index}
                                            style={{ width: '100%' }}
                                        >
                                            <Chip
                                                label={`${contact?.title} (${contact?.type})`}
                                                disabled={loadingGeofence || loadingResponse}
                                                handleDelete={() => {
                                                    const newContacts = contacts?.filter(
                                                        (c) => c?.id != contact?.id,
                                                    );

                                                    setContacts(newContacts);
                                                    dispatch(mapGeofencesContactsSave({
                                                        ...geofence,
                                                        contacts: newContacts.map(nc => {
                                                            return nc.id
                                                        })
                                                    }));
                                                }}
                                            />
                                        </Grid>
                                    );
                                })}
                            </Grid> :
                            <div>
                                {
                                    !loadingGeofence && !loadingResponse &&
                                    <span>{messages['map_geofence_geofenceContacts_noContacts']}</span>
                                }
                            </div>
                    }
                </div>
            </ModalBody>

            <ModalFooter style={{ bottom: 50 }}>
                <Button
                    disabled={loadingGeofence || loadingResponse}
                    onClick={handleClose}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    disabled={loadingGeofence || loadingResponse}
                    onClick={() => {
                        handleClose();
                        dispatch(mapGeofencesOpenEditCreateModal(true, geofence?.id));
                    }}
                    className="btn-blue"
                >
                    {messages['edit']}
                </Button>
            </ModalFooter>
        </Modal >
    )
}

export default GeofenceContacts;